import { InjectionToken } from '@angular/core';
import { Method } from 'eurogard-pattern';

export const TABLE_HEADER_BUTTON_METHOD = new InjectionToken<Method>('table-header-button-method');
